import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { Container, Anchor } from './styles';
import { Box } from '@mui/material';
import { getEnv } from 'utils';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import ja from './locales/en';
import zh from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import { useRouter } from 'next/router';

const Props = {
  children: PropTypes.node.isRequired,
};

const ItemProps = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool,
};

const ItemDefaultProps = {
  href: undefined,
  isDisabled: false,
};

function BreadcrumbItem({ href, children, isDisabled }) {
  if (isDisabled || !href) {
    return <Anchor isDisabled>{children}</Anchor>;
  }

  return (
    <Link href={href}>
      <Anchor>{children}</Anchor>
    </Link>
  );
}

BreadcrumbItem.propTypes = ItemProps;
BreadcrumbItem.defaultProps = ItemDefaultProps;

export default function Breadcrumbs({ children }) {
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  return (
    <Box pt={3}>
      <Container>
        <Anchor href={`${getEnv('MTG_URL_APP')}`}>{t.home}</Anchor>
        {children}
      </Container>
    </Box>
  );
}

Breadcrumbs.propTypes = Props;
Breadcrumbs.Item = BreadcrumbItem;
